


















































































































































































import { Component, Prop, Ref, Vue } from "vue-property-decorator";
import { VForm } from "@/common/vuetify_types";
import { noSpace, requiredString, validateCharacter } from "@/tool/validation";
import moment from "moment";
import { customHourMinAdder, dateFormat } from "@/common/date_format";
import { CalendarEventType, FullPatientCalendar } from "@/api";
import { selfData } from "@/common/role_utils";

type CustomEvent = {
  id: number;
  name: string;
  description: string;
  start: string;
  end: string;
  time: string;
  color: string;
  patient: string;
  location: string;
  timed: boolean;
  eventTypeId: number;
  eventType: string;
  eventColor: string;
};

@Component
export default class PatientCalendarEventForm extends Vue {
  @Ref("form") form!: VForm;
  @Prop() readonly propEvent!: CustomEvent;
  @Prop() payload!: FullPatientCalendar;
  @Prop() readonly isupdate!: boolean;

  event: CustomEvent = JSON.parse(JSON.stringify(this.propEvent));
  firstNameInitial = "";
  lastNameInitial = "";
  startDatePicker = false;
  formattedStartDate = "";
  minDate = moment()
    .local()
    .format("YYYY-MM-DD");
  startTimePicker = false;
  commentError = "";
  textRules = [requiredString, noSpace];
  charRules = [validateCharacter];
  saving = false;

  created() {
    this.event.start = this.event.start.substring(0, 10);
    this.event.end = this.event.end.substring(0, 10);
    this.firstNameInitial =
      this.event.patient.split(" ")[0][0].toUpperCase() || "";
    this.lastNameInitial =
      this.event.patient.split(" ")[1][0].toUpperCase() || "";
    this.formatDate(this.event.start);
  }

  get eventTypes() {
    return (
      (this.$store.getters[
        "patientCalendar/calendarEventTypes"
      ] as CalendarEventType[]) || []
    );
  }

  formatDate(date: string) {
    if (!date) return;
    this.formattedStartDate = dateFormat(date);
  }

  udpateTime() {
    this.event.time = "";
  }

  onEventSubmit() {
    const isValid = this.form.validate();
    if (isValid) {
      const startDate = customHourMinAdder(
        this.event.start,
        this.event.time || "",
      );
      const eventType = this.eventTypes.find(
        (item: CalendarEventType) => item.id === this.event.eventTypeId,
      );
      const payload: FullPatientCalendar = {
        patientCalendar: {
          companyID: selfData().companyId,
          createdByID: selfData().id,
          title: this.event.name,
          description: this.event.description,
          date: startDate,
          time: this.event.time,
          eventTypeID: this.event.eventTypeId,
          patient:
            this.firstNameInitial.toUpperCase() +
            " " +
            this.lastNameInitial.toUpperCase(),
          location: this.event.location,
          createdAt: moment()
            .utc()
            .toISOString(),
        },
        eventType: {
          id: this.event.eventTypeId,
          type: eventType?.type || this.event.eventType,
          color: eventType?.color || this.event.eventColor,
        },
        createdBy: {
          id: selfData().id,
          name: `${selfData().firstName} ${selfData().lastName}`,
        },
      };
      if (this.isupdate) {
        this.eventUpdate(payload);
      } else {
        this.eventSubmit(payload);
      }
    }
  }

  async eventUpdate(payload: FullPatientCalendar) {
    this.saving = true;
    if (this.propEvent.id) payload.patientCalendar.id = this.propEvent.id;
    await this.$store.dispatch(
      "patientCalendar/updatePatientCalendarEvent",
      payload,
    );
    this.saving = false;
    this.close();
  }

  async eventSubmit(payload: FullPatientCalendar) {
    this.saving = true;
    await this.$store.dispatch(
      "patientCalendar/addPatientCalendarEvent",
      payload,
    );
    this.saving = false;
    this.close();
  }

  close() {
    this.form.reset();
    this.$emit("close");
  }
}
